import { NoResultsEmptyStateBase } from "@faire/retailer-visitor-shared/components/NoResults/NoResultsEmptyStateBase";
import { EmbeddedLink } from "@faire/web/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import type { JSX } from "react";

interface INoResultsContainerProps {
  onClearFilters?: () => void;
  className?: string;
  hasFiltersApplied?: boolean;
  showProductFirstResults: boolean | undefined;
  divRef?: React.Ref<HTMLDivElement>;
}

export const NoResultsContainer: React.FC<INoResultsContainerProps> = ({
  onClearFilters,
  className,
  hasFiltersApplied,
  showProductFirstResults,
  divRef,
}) => {
  let title = noResultsTitle;
  let subtitle = showBrandFirstSubtitle;
  if (hasFiltersApplied) {
    title = noFilteredResultsTitle;
    subtitle = hasFiltersAppliedSubtitle(onClearFilters);
  } else if (showProductFirstResults) {
    subtitle = showProductFirstSubtitle;
  }
  return (
    <NoResultsEmptyStateBase
      className={className}
      title={title}
      subtitle={subtitle}
      divRef={divRef}
    />
  );
};

const noResultsTitle = (
  <StrictLocalMsg id="GfZOq+" defaultMessage="No results available" />
);

export const noFilteredResultsTitle = (
  <StrictLocalMsg
    id="JmpNaC"
    defaultMessage="No results match these filters"
    description={{
      text: "This sentence is shown on the product search page or the catnav page when there are no product results that match all the active filters.",
      img: "https://cdn.faire.com/fastly/0cec416c5d825a57079466e74dbabd83a8ba19cf0ee6c715a27fa539899a27b7.png",
    }}
  />
);

export const hasFiltersAppliedSubtitle = (
  onClearFilters: () => void = () => {}
) => (
  <StrictLocalMsg
    id="1snLu3"
    defaultMessage="Adjust or clear your filters to see more results. <ButtonFormatting>Clear Filters</ButtonFormatting>"
    description={{
      text: "This sentence is shown on the product search page when there are no search results that match all the active filters. Users can click on 'Clear Filters' to clear all active filters.",
      img: "https://cdn.faire.com/fastly/0cec416c5d825a57079466e74dbabd83a8ba19cf0ee6c715a27fa539899a27b7.png",
    }}
    values={{
      ButtonFormatting: (chunks: JSX.Element) => (
        <EmbeddedLink onClick={onClearFilters}>{chunks}</EmbeddedLink>
      ),
    }}
  />
);

const showProductFirstSubtitle = (
  <StrictLocalMsg
    id="mcDOwO"
    defaultMessage="Try visiting other categories to discover more products"
  />
);

const showBrandFirstSubtitle = (
  <StrictLocalMsg
    id="jniKs/"
    defaultMessage="Try visiting other categories to discover more brands"
  />
);
